export default __webpack_public_path__ + "static/media/logo.88659f29.png";